// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LlN2","colBig":"styles_colBig__5Dwlj","colSmall":"styles_colSmall__36Eo9"};